// Slots Oceans source branding still uses raw agent IDs. Its central chat
// records use realm-qualified IDs. Normalize only that known realm so an
// unrelated tenant's agent can never be treated as the same person.
const SLOTS_REALM_PREFIX = 'slots-oceans:';
const SLOTS_SOURCE_TENANT_ID = '661abea4-94a9-4a1e-acc2-b9dd3bb21268';
const SLOTS_CENTRAL_TENANT_ID = `${SLOTS_REALM_PREFIX}${SLOTS_SOURCE_TENANT_ID}`;

export const normalizeSlotsAgentId = (value) => {
  const id = String(value || '').trim();
  return id.startsWith(SLOTS_REALM_PREFIX) ? id.slice(SLOTS_REALM_PREFIX.length) : id;
};

export const slotsCentralAgentId = (value, tenantId) => {
  const id = String(value || '').trim();
  if (
    !id
    || (id.includes(':') && !id.startsWith(SLOTS_REALM_PREFIX))
    || ![SLOTS_SOURCE_TENANT_ID, SLOTS_CENTRAL_TENANT_ID].includes(String(tenantId || '').trim())
  ) {
    return id;
  }
  return `${SLOTS_REALM_PREFIX}${normalizeSlotsAgentId(id)}`;
};

export const sameChatAgentId = (selectedId, targetId, messageTenantId) => {
  const selected = String(selectedId || '').trim();
  const target = String(targetId || '').trim();
  if (!selected || !target) return false;
  if (selected === target) return true;
  if (String(messageTenantId || '').trim() !== SLOTS_CENTRAL_TENANT_ID) return false;
  return slotsCentralAgentId(selected, messageTenantId) === slotsCentralAgentId(target, messageTenantId);
};

export const slotsAgentUnreadKey = (id, name) => {
  const cleanId = normalizeSlotsAgentId(id);
  if (cleanId) return `id:${cleanId}`;
  const cleanName = String(name || '').trim().toLowerCase();
  return cleanName ? `name:${cleanName}` : 'support';
};
